//import React from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { enableLightTheme } from "../../redux/actions/themeActions";
import React, { PureComponent } from "react";
//import { Link } from "react-router-dom";
import * as myConstClass from "../../constant.js";
import { MoreVertical, RefreshCw } from "react-feather";
import $ from "jquery";
import "react-quill/dist/quill.snow.css";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import Select from "react-select";
import "react-quill/dist/quill.bubble.css";
//import * as Icon from "react-feather";
import { faExternalLinkAlt } from "@fortawesome/free-solid-svg-icons";
import cryptoRandomString from "crypto-random-string";
import {
  CustomInput,
  button,
  Navbar,
  NavbarBrand,
  Breadcrumb,
  BreadcrumbItem,
  Buttonn,
  Row,
  Col,
  Label,
  Input,
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  CardLink,
  CardText,
  Container,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Button,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  CardImg,
  Table,
  UncontrolledDropdown,
} from "reactstrap";
import avatar3 from "../../assets/img/avatars/avatar-3.jpg";
import screenshotThemeModern from "../../assets/img/screenshots/modern.png";
import screenshotThemeDark from "../../assets/img/screenshots/dark.png";
import screenshotThemeLight from "../../assets/img/screenshots/light.png";

import brandBootstrap from "../../assets/img/brands/bootstrap.svg";
import brandBootstrapB from "../../assets/img/brands/b.svg";
import brandSass from "../../assets/img/brands/sass.svg";
import brandWebpack from "../../assets/img/brands/webpack.svg";
import brandNpm from "../../assets/img/brands/npm.svg";
import brandReact from "../../assets/img/brands/react.svg";
import brandRedux from "../../assets/img/brands/redux.svg";

import IosPulse from "react-ionicons/lib/IosPulse";
//import Header from "../../components/Header";
import HeaderTitle from "../../components/HeaderTitle";
//import './common.scss';
import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider from "react-bootstrap-table2-toolkit";
import paginationFactory from "react-bootstrap-table2-paginator";
import { toastr } from "react-redux-toastr";
import * as Icon from "react-feather";
import CsvDownloader from "react-csv-downloader";
import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
import { Redirect } from "react-router-dom";
import swal from "sweetalert";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar } from "@fortawesome/free-solid-svg-icons";
import {
  AvForm,
  AvField,
  AvGroup,
  AvInput,
  AvFeedback,
  AvRadioGroup,
  AvRadio,
  AvCheckboxGroup,
  AvCheckbox,
} from "availity-reactstrap-validation";
//const avatar = myConstClass.SITE_URL+`img/jobimage.png`;

/**
 * Shared design tokens for the careers page — a navy/slate corporate
 * palette (keeps the existing #153d77 brand navy as primary) with a
 * single bright accent reserved for primary actions (Apply, Submit).
 */
const UI = {
  primary: "#153d77",
  primaryDark: "#0e2c57",
  primaryLight: "#e7edf6",
  accent: "#2563eb",
  accentDark: "#1d4ed8",
  success: "#16a34a",
  surface: "#ffffff",
  surfaceMuted: "#f5f7fb",
  border: "#e2e8f0",
  text: "#0f172a",
  textMuted: "#64748b",
  radius: 16,
  radiusSm: 10,
  shadow: "0 1px 2px rgba(15,23,42,0.06), 0 1px 6px rgba(15,23,42,0.06)",
  shadowMd: "0 10px 25px -8px rgba(15,23,42,0.18)",
};

const tablestyle = {
  borderTop: "none",
  borderRight: "none",
  borderBottom: `1px solid ${UI.border}`,
  fontSize: "14px",
  fontWeight: 600,
  color: UI.textMuted,
  textTransform: "uppercase",
  letterSpacing: "0.04em",
  width: "30%",
  verticalAlign: "top",
  paddingTop: "14px",
  paddingBottom: "14px",
  paddingRight: "18px",
};
const tablestyletd = {
  borderTop: "none",
  borderBottom: `1px solid ${UI.border}`,
  fontSize: "15px",
  color: UI.text,
  verticalAlign: "top",
  paddingTop: "14px",
  paddingBottom: "14px",
  paddingLeft: "18px",
};

class Landing extends PureComponent {
  constructor(props) {
    super(props);
    //this.routeChange = this.routeChange.bind(this);
    // this.googleTranslateElementInit = this.googleTranslateElementInit.bind(this);
    //      this.search = this.search.bind(this);
    //this.toggledocTemplate1=this.toggledocTemplate1(this);
    this.state = { file: "" };
    this.state = {
      user_id: 0,
      formData: "",
      emp: "",
      posts: "",
      timeOut: 5000,
      showCloseButton: true,
      progressBar: true,
      position: "top-right",
      jobpostid: "",
      count: "",
      text1: "",
      text2: "",
      text3: "",
      text4: "",
      text5: "",
      text6: "",
      text7: "",
      text8: "",
      text9: "",
      text10: "",
      //submitted: true,
      visiblepoints: false,
      visiblepoints1: false,
      visiblediscloser: false,

      organization_url_see: "",
      organization_logo_see: "",
      organization_title_see: "",
      job_title_see: "",
      job_desc_see: "",
      textShort_Description: "",
      textJobTitle: "",
      Longdescwithouthtml: "",
      isreadlong: "",
      account_id: "",
      account_name: "",
      submitted: true,
    };

    this.state = {
      jobpostidnew: "",
      selected: [],
      costs: [],
      imagess: [],
      titleorg: [],
      quantities: [],
      accountnm: [],
      job_title: [],
      job_desc: [],
    };
    //this.ochange = this.ochange.bind(this);
    this.change = this.change.bind(this);
    this.change1 = this.change1.bind(this);
    //this.oid=0;
    this.handleCheckChange = this.handleCheckChange.bind(this);
    this.routeChange = this.routeChange.bind(this);
    //for export
    this.csvColumns = [
      {
        displayName: "Title",
        id: "title",
      },
      {
        displayName: "Code",
        id: "code",
      },
      {
        displayName: "Description",
        id: "description",
      },
    ];

    //submitted: false,
  }

  edit(e) {
    //this.props.history.push('/'+myConstClass.TENANT_PAGE_PATH+'jobpost/add/'+e);
    const id1 = cryptoRandomString({ length: 10, type: "url-safe" });

    this.props.history.push({
      pathname: "/" + myConstClass.TENANT_PAGE_PATH + "blog/add/" + id1,
      state: {
        _id: e,
      },
    });
  }

  routeChange() {
    this.props.history.push("/");
  }

  handleCheckChange() {
    //  alert(this.state.checked);
    this.setState({
      submitted: this.state.checked,
    });
    this.setState({
      checked: !this.state.checked,
    });
  }

  toggledocTemplate = (open_mod1) => {
    this.state.jobpostid = open_mod1;
    this.setState((state) => ({
      [open_mod1]: !state[open_mod1],
    }));
  };

  toggledocTemplateApply = (open_mod1) => {
    //  alert(open_mod1);
    //  alert(open_mod1);

    // var account_name=localStorage.getItem("account_name");

    // alert(answer_array);
    //var account_name=answer_array[2];
    // fetch(
    //   myConstClass.CARREER_URL +
    //     this.state.account_name +
    //     "/index.php/career/getjobpostInfo/" +
    //     open_mod1
    // )
    fetch(
      myConstClass.BASE_URL+"career/getjobpostInfo/" +
        open_mod1
    )
      .then((response) => response.json())
      .then((response) => {
        this.setState({ textmoreJDDesc: response.Description });
        this.setState({ text2: response.JobTitle });
        this.setState({ text3: response.JobType });
        this.setState({ text4: response.Position });
        this.setState({ text5: response.date_of_closing });
        this.setState({ url: response.http_link });
        this.setState({
          Longdescwithouthtml: response.Long_Descriptionwithouthtml,
        });
        this.setState({ JDdescwithouthtml: response.Descriptionmore });
        this.setState({ isreadlong: response.isreadlong });
        this.setState({ isreadjddesc: response.isreadjddesc });
        this.setState({ text1: response.Long_Description });
        this.setState({ textJobTitle: response.JTitle });
        this.setState({ textShort_Description: response.Short_Description });
        this.setState({ jdtitle: response.jdtitle });
        this.setState({ Functionsmore: response.Functionsmore });
        this.setState({ Functions: response.Functions });
        this.setState({ isreadfunction: response.isreadfunction });
        this.setState({ Qualification: response.Qualification });
        this.setState({ Qualificationmore: response.Qualificationmore });
        this.setState({ isreadQualification: response.isreadQualification });

        this.setState({ Responsibilities: response.Responsibilities });
        this.setState({ Responsibilitiesmore: response.Responsibilitiesmore });
        this.setState({
          isreadResponsibilities: response.isreadResponsibilities,
        });
      })
      .catch((err) => console.log(err));

    this.setState({ checked: false });
    this.setState({ submitted: true });

    this.state.jobpostid = open_mod1;
    this.setState((state) => ({
      [open_mod1]: !state[open_mod1],
    }));
  };

  toggleEdit = () => {
    this.setState({ visiblepoints: false });
  };

  toggleDes = () => {
    //this.state.jobpostidnew =  open_mod;

    this.setState({ visiblepoints1: true });

    this.setState({ visiblepoints1: true });
  };
  toggleDesMore1 = () => {
    $("#readmore1").hide();
    $("#notreadmore1").show();
  };
  toggleDesLess1 = () => {
    $("#notreadmore1").hide();
    $("#readmore1").show();
  };

  toggleDesMore = () => {
    //this.state.jobpostidnew =  open_mod;

    //this.setState({'visiblepoints1':true});

    //this.setState({'visiblepoints1':true});
    $("#readmore").hide();
    $("#notreadmore").show();
  };
  toggleDesLess = () => {
    //this.state.jobpostidnew =  open_mod;

    //this.setState({'visiblepoints1':true});

    $("#notreadmore").hide();
    $("#readmore").show();
    //this.setState({'visiblepoints1':true});
  };

  toggleEdit1 = (open_mod) => {
    //this.state.jobpostidnew =  open_mod;
    this.setState((state) => ({
      [open_mod]: !state[open_mod],
    }));

    this.setState({ visiblepoints1: false });
  };

  toggledocTemplate1(e) {
    //alert(e);

    this.state.jobpostidnew = e;

    this.setState({ visiblepoints: true });

    // alert(answer_array);
    //var account_name=answer_array[2];
    //var account_name=localStorage.getItem("account_name");

    //this.state.user_id = answer_array['5'];
    // fetch(
    //   myConstClass.CARREER_URL +
    //     this.state.account_name +
    //     "/index.php/career/getjobpostInfo/" +
    //     this.state.jobpostidnew
    // )
    fetch(
      myConstClass.BASE_URL+"career/getjobpostInfo/" +
      this.state.jobpostidnew
    )
      .then((response) => response.json())
      .then((response) => {
        this.setState({ textmoreJDDesc: response.Description });
        this.setState({ text2: response.JTitle });
        this.setState({ text3: response.JobType });
        this.setState({ text4: response.Position });
        this.setState({ text5: response.date_of_closing });
        this.setState({ url: response.http_link });
        this.setState({
          Longdescwithouthtml: response.Long_Descriptionwithouthtml,
        });
        this.setState({ JDdescwithouthtml: response.Descriptionmore });
        this.setState({ isreadlong: response.isreadlong });
        this.setState({ isreadjddesc: response.isreadjddesc });
        this.setState({ text1: response.Long_Description });
        this.setState({ textJobTitle: response.JTitle });
        this.setState({ textShort_Description: response.Short_Description });
        this.setState({ jdtitle: response.jdtitle });
        this.setState({ Functionsmore: response.Functionsmore });
        this.setState({ Functions: response.Functions });
        this.setState({ isreadfunction: response.isreadfunction });
        this.setState({ Qualification: response.Qualification });
        this.setState({ Qualificationmore: response.Qualificationmore });
        this.setState({ isreadQualification: response.isreadQualification });
        this.setState({ Responsibilities: response.Responsibilities });
        this.setState({ Responsibilitiesmore: response.Responsibilitiesmore });
        this.setState({
          isreadResponsibilities: response.isreadResponsibilities,
        });

        this.setState({ Reporting: response.Reporting });
        this.setState({ Reportingmore: response.Reportingmore });
        this.setState({ isreadReporting: response.isreadReporting });

        this.setState({ Salary: response.Salary });
        this.setState({ Salarymore: response.Salarymore });
        this.setState({ isreadReporting: response.isreadReporting });

        this.setState({ Shifts: response.Shifts });
        this.setState({ Shiftsmore: response.Shiftsmore });
        this.setState({ isreadShifts: response.isreadShifts });

        this.setState({ Perks: response.Perks });
        this.setState({ Perksmore: response.Perksmore });
        this.setState({ isreadPerks: response.isreadPerks });

        this.setState({ Benefits: response.Benefits });
        this.setState({ Benefitsmore: response.Benefitsmore });
        this.setState({ isreadBenefits: response.isreadBenefits });
        // this.setState({ text6: response.Gender })
        if (response.Gender == "1") {
          this.setState({ text7: "Male" });
        } else if (response.Gender == "2") {
          this.setState({ text7: "Female" });
        } else if (response.Gender == "3") {
          this.setState({ text7: "No Preference" });
        }

        // else{
        //  this.setState({ text7:'Male'  })
        // }

        if (response.Minimum_Experience == 1) {
          this.setState({ text6: "Fresher" });
        } else if (response.Minimum_Experience == 2) {
          this.setState({ text6: "1 Year" });
        } else if (response.Minimum_Experience == 3) {
          this.setState({ text6: "2 Year" });
        } else if (response.Minimum_Experience == 4) {
          this.setState({ text6: "3 Year" });
        } else if (response.Minimum_Experience == 5) {
          this.setState({ text6: "4 Year" });
        } else if (response.Minimum_Experience == 6) {
          this.setState({ text6: "5 Year" });
        } else if (response.Minimum_Experience == 7) {
          this.setState({ text6: "6 Year" });
        } else if (response.Minimum_Experience == 8) {
          this.setState({ text6: "7 Year" });
        } else if (response.Minimum_Experience == 9) {
          this.setState({ text6: "8 Year" });
        } else if (response.Minimum_Experience == 10) {
          this.setState({ text6: "9 Year" });
        } else if (response.Minimum_Experience == 11) {
          this.setState({ text6: "10 Year" });
        } else if (response.Minimum_Experience == 12) {
          this.setState({ text6: "10+ Year" });
        }

        this.setState({ text9: response.Positions });
        this.setState({ text8: response.Short_Description });
        this.setState({ text10: response.posted_date });
        // this.setState({ Long_Description: response.Long_Description })
        //this.setState({JD_Title:[{ value:response.JD_Title, label:response.jdtitle }]});
      })
      .catch((err) => console.log(err));
  }

  // remove(e) {
  //   this.flag = 1;
  //   var admin_id = localStorage.getItem('uname');
  //   const options = {
  //       timeOut: parseInt(this.state.timeOut),
  //       showCloseButton: this.state.showCloseButton,
  //       progressBar: this.state.progressBar,
  //       position: this.state.position
  //     };
  //     this.flag = 1;
  //   confirmAlert({
  //     title: '',
  //     message: 'Are you sure ?',
  //     buttons: [
  //       {
  //         label: 'Yes',
  //         onClick: () =>    fetch(myConstClass.BASE_URL+`announcements/deleteAnnouncement`, {
  //           method: 'POST',
  //           body: e,
  //         }).then(toastr.success(
  //           'Success',
  //           "Announcement Deleted Successfully..!",
  //           options
  //         ), fetch(myConstClass.BASE_URL+'announcements/getAnnouncement/'+admin_id)
  //         .then(response => response.json())
  //         .then(response =>{
  //           let i=1;
  //         response.forEach(element => {
  //           let id=element.uid;
  //         element.action = <div><Icon.Edit3 style={{margin:'0px 15px 0px 0px',cursor:'Pointer'}} onClick={() =>this.edit(id)} /><Icon.Trash2 style={{cursor:'Pointer'}} onClick={() =>this.remove(id)}/></div>;
  //          // console.log(element);
  //          element.uid = i;
  //          i++;
  //         });
  //         this.setState({formData: response})
  //       }).catch(err => console.log(err))
  //         )
  //         .catch()
  //       },
  //       {
  //         label: 'No',
  //         onClick: () => <Redirect to='announcements/listing'  />
  //       }
  //     ]
  //   });
  // }

  change = (selectedOrg) => {
    // alert(answer_array);
    //var account_name=answer_array[2];
    this.setState({ selectedOrg });
    // var new_account_id = localStorage.getItem('account_id');
    // this.cid = event.target.value;
    if (selectedOrg == null || selectedOrg == undefined) {
      this.cid = 0;
    } else {
      let x = Object.values(selectedOrg);
      // this.dep_id = event.target.value;
      this.cid = x[0];
    }
    if (this.pos_id == null || this.pos_id == "") {
      this.pos_id = 0;
    } else {
      this.pos_id = this.pos_id;
    }
    if (this.dep_id == null || this.dep_id == "") {
      this.dep_id = 0;
    } else {
      this.dep_id = this.dep_id;
    }
    if (this.oid == null || this.oid == undefined) {
      this.oid = 0;
    } else {
      this.oid = this.oid;
    }

    fetch(
      myConstClass.CARREER_URL +
        this.state.account_name +
        "/index.php/career/getjobpostInfoallc/" +
        this.state.account_id +
        "/" +
        this.cid +
        "/" +
        this.oid
    )
      .then((response) => response.json())
      .then((response) => {
        let i = 1;
        let c = 1;
        response.forEach((element) => {
          let id = element.id;
          element.action = (
            <div>
              <Icon.Edit3
                style={{ margin: "0px 15px 0px 0px", cursor: "Pointer" }}
                onClick={() => this.toggledocTemplate(id)}
              />
            </div>
          );
          // console.log(element);
          // element.id = i;
          i++;
          c++;
        });

        //this.setState({org: response})
        this.setState({ formData: response });
        this.setState({ count: c });
      })
      .catch((err) => console.log(err));
  };

  change1 = (selectedOrg) => {
    // alert(answer_array);
    //var account_name=answer_array[2];
    this.setState({ organization_id1: selectedOrg });
    // var new_account_id = localStorage.getItem('account_id');
    // this.cid = event.target.value;
    if (selectedOrg == null || selectedOrg == undefined) {
      this.oid = 0;
    } else {
      let x = Object.values(selectedOrg);
      // let xii = indexOf(selectedOrg);
      //alert(xii);
      // this.dep_id = event.target.value;
      this.oid = x[0];
    }

    var indexoforg = this.state.selected.indexOf(this.oid);

    //alert(indexoforg);

    var organization_url = this.state.costs[indexoforg];
    var organization_logo = this.state.imagess[indexoforg];
    var organization_title = this.state.titleorg[indexoforg];
    //alert(this.state.costs);
    this.setState({ organization_url_see: organization_url });
    this.setState({ organization_logo_see: organization_logo });
    this.setState({ organization_title_see: organization_title });
    if (this.pos_id == null || this.pos_id == "") {
      this.pos_id = 0;
    } else {
      this.pos_id = this.pos_id;
    }
    if (this.dep_id == null || this.dep_id == "") {
      this.dep_id = 0;
    } else {
      this.dep_id = this.dep_id;
    }

    fetch(
      myConstClass.CARREER_URL +
        this.state.account_name +
        "/index.php/career/getjobpostInfoallc/" +
        this.state.account_id +
        "/" +
        this.cid +
        "/" +
        this.oid
    )
      .then((response) => response.json())
      .then((response) => {
        let i = 1;
        let c = 1;
        response.forEach((element) => {
          let id = element.id;
          element.action = (
            <div>
              <Icon.Edit3
                style={{ margin: "0px 15px 0px 0px", cursor: "Pointer" }}
                onClick={() => this.toggledocTemplate(id)}
              />
            </div>
          );
          // console.log(element);
          // element.id = i;
          i++;
          c++;
        });

        //this.setState({org: response})
        this.setState({ formData: response });
        this.setState({ count: c });
      })
      .catch((err) => console.log(err));
  };

  componentDidMount() {
    const answer_array = this.props.location.pathname.split("/");

    //alert(answer_array);
    var company_name = answer_array[2];

    //   var login_type= localStorage.getItem('login_type');
    // alert(login_type);

    localStorage.setItem("joburl", "1");

    fetch(myConstClass.BASE_URL + "organization/getJd_disclouser_Info")
      .then((response) => response.json())
      .then((response) => {
        //this.setState({category:[{ value:response.category, label:response.ttitle }]});
        if (response) {
          this.setState({ text: response.Description });
          this.setState({ user_id: "1" });
        } else {
          this.setState({ user_id: "0" });
        }
      })
      .catch((err) => console.log(err));

    //  var new_account_id= localStorage.getItem('account_id');
    fetch(
      myConstClass.LOGIN_URL +
        "career/get_all_organizationsbycompany/" +
        company_name
    )
      .then((response) => response.json())
      .then((response) => {
        response.forEach((element) => {
          //this.setState({totalccspan: response.totalAmount});
          // alert(element.id);

          /*  element.action = <div><Icon.Edit3 style={{margin:'0px 15px 0px 0px',cursor:'Pointer'}} onClick={() =>this.edit(id)} /><Icon.Trash2 style={{cursor:'Pointer'}} onClick={() =>this.remove(id)}/></div>;
             // console.log(element);
             element.id = i;
             i++;*/

          this.setState(() => ({
            // selected: this.state.selected ? [...this.state.selected, row.id] : []
            quantities: [...this.state.quantities, element.tenant_id],
          }));

          this.setState(() => ({
            // selected: this.state.selected ? [...this.state.selected, row.id] : []
            selected: [...this.state.selected, element.id],
          }));

          this.setState(() => ({
            // selected: this.state.selected ? [...this.state.selected, row.id] : []
            costs: [...this.state.costs, element.http_link],
          }));

          this.setState(() => ({
            // selected: this.state.selected ? [...this.state.selected, row.id] : []
            imagess: [...this.state.imagess, element.org_logo_url],
          }));

          this.setState(() => ({
            // selected: this.state.selected ? [...this.state.selected, row.id] : []
            titleorg: [...this.state.titleorg, element.title],
          }));

          this.setState(() => ({
            // selected: this.state.selected ? [...this.state.selected, row.id] : []
            accountnm: [...this.state.accountnm, element.account_name],
          }));
        });
        var accountname = this.state.accountnm[0];
        var accountnid = this.state.quantities[0];
        //alert(localStorage.getItem('account_id_new'));
        //this.setState({account_id:localStorage.getItem('account_id_new')});

        var organization_id1 = this.state.selected[0];
        //alert(accountname);
        var organization_url = this.state.costs[0];
        var organization_logo = this.state.imagess[0];
        var organization_title = this.state.titleorg[0];
        //alert(this.state.costs);
        this.setState({ account_name: accountname });
        this.setState({ organization_url_see: organization_url });
        this.setState({ organization_logo_see: organization_logo });
        this.setState({ organization_title_see: organization_title });
        this.setState({ organization_id11: organization_id1 });
        this.setState({ account_id: accountnid });

        if (this.cid == null || this.cid == undefined) {
          this.cid = 0;
        } else {
          this.cid = this.cid;
        }

        if (this.oid == null || this.oid == undefined) {
          this.oid = organization_id1;
        } else {
          this.oid = this.oid;
        }

        // document.body.appendChild(script);

        //    document.querySelector('.react-bootstrap-table').style.minHeight  = "243px";

        // fetch(
        //   myConstClass.CARREER_URL +
        //     accountname +
        //     "/index.php/career/getjobpostInfoallc/" +
        //     accountnid +
        //     "/" +
        //     this.cid +
        //     "/" +
        //     this.oid
        // )
        fetch(
          //   myConstClass.BASE_URL +
          //     accountname +
          //     "/index.php/career/getjobpostInfoallc/" +
          //     accountnid +
          //     "/" +
          //     this.cid +
          //     "/" +
          //     this.oid
          // )
          myConstClass.BASE_URL +
            "career/getjobpostInfoallc/" +
            accountnid +
            "/" +
            this.cid +
            "/" +
            this.oid
        )
          .then((response) => response.json())
          .then((response) => {
            let i = 1;
            let c = 1;
            response.forEach((element) => {
              let id = element.id;
              element.action = (
                <div>
                  <Icon.Edit3
                    style={{ margin: "0px 15px 0px 0px", cursor: "Pointer" }}
                    onClick={() => this.toggledocTemplate(id)}
                  />
                </div>
              );
              // console.log(element);
              // element.id = i;
              i++;
              c++;

              this.setState(() => ({
                // selected: this.state.selected ? [...this.state.selected, row.id] : []
                job_title: [...this.state.job_title, element.JobTitle],
              }));

              this.setState(() => ({
                // selected: this.state.selected ? [...this.state.selected, row.id] : []job_titlejob_desc
                job_desc: [...this.state.job_desc, element.Short_Description],
              }));
            });

            //  this.setState({org: response})
            this.setState({ formData: response });
            this.setState({ count: c });
          })
          .catch((err) => console.log(err));
        //var admin_id= localStorage.getItem('uname');
        // fetch(
        //   myConstClass.CARREER_URL +
        //     accountname +
        //     "/index.php/organization/get_all_jd/" +
        //     this.state.account_id
        // )
        fetch(myConstClass.BASE_URL +
        "organization/get_all_jd/" +
        accountnid +
        "/" +
        this.cid +
        "/" +
        this.oid
    )
          .then((response) => response.json())
          .then((response) => {
            this.setState({ org: response });
          })
          .catch((err) => console.log(err));

        //this.setState({organization_id1:[{ value: organization_id1, label: organization_title }]});
        this.setState({ emp: response });
      })
      .catch((err) => console.log(err));

    //alert(this.oid);
  }

  onDocChangeHandler(e) {
    e.preventDefault();
    let reader = new FileReader();
    let file = e.target.files[0];
    reader.onloadend = () => {
      this.setState({
        file: file,
        // imagePreviewUrl: reader.result
      });
    };
    reader.readAsDataURL(file);
  }

  handleValidSubmitDocument = () => {
    //alert(this.state.file);
    if (this.state.file != undefined) {
      // alert(answer_array);
      //var account_name=answer_array[2];
      this.setState({ submitted: true }, () => {
        // setTimeout(() => this.setState({ submitted: false }), 5000);
        const data = new FormData();
        data.append("file", this.state.file);
        data.append("jobpostid", this.state.jobpostid);
        data.append("formdata", JSON.stringify($("#doform").serializeArray()));
        fetch(
          // myConstClass.CARREER_URL +
          //   this.state.account_name +
          //   `/index.php/career/add_applydocumment/` +
          //   this.state.account_id,
          myConstClass.BASE_URL +`/career/add_applydocumment/` +
            this.state.account_id,
          {
            method: "POST",
            body: data,
            // contentType: "application/json; charset=utf-8",
          }
        )
          .then((response) => response.json())
          .then((response) => {
            this.setState({ submitted: false });
            if (response == true) {
              //this.state.jobpostid =  open_mod1;
              this.setState((state) => ({
                [this.state.jobpostid]: !state[this.state.jobpostid],
              }));

              this.state.user_id == "0"
                ? toastr.success(
                    "Success",
                    "Resume Uploaded Successfully..!",
                    this.options
                  )
                : toastr.success(
                    "Success",
                    "Resume Uploaded Successfully..!",
                    this.options
                  );

              // this.props.history.push('/'+myConstClass.TENANT_PAGE_PATH+'complaints/listing');
            } else {
              toastr.error(
                "Error",
                "Resume Not Uploaded Successfully..!",
                this.options
              );
            }
          })
          .catch();
      });
    } else {
      toastr.error("Error", "Please Upload Resume ..!", this.options);
    }
  };

  view() {
    this.setState({ visiblediscloser: true });
  }

  toggleDesMore1 = () => {
    $("#readmore1").hide();
    $("#notreadmore1").show();
  };
  toggleDesLess1 = () => {
    $("#notreadmore1").hide();
    $("#readmore1").show();
  };
  toggleDesMore3 = () => {
    $("#readmore3").hide();
    $("#notreadmore3").show();
  };
  toggleDesLess3 = () => {
    $("#notreadmore3").hide();
    $("#readmore3").show();
  };

  toggleDesMore4 = () => {
    $("#readmore4").hide();
    $("#notreadmore4").show();
  };
  toggleDesLess4 = () => {
    $("#notreadmore4").hide();
    $("#readmore4").show();
  };

  toggleDesMoreAll = (id) => {
    $("#readmore" + id).hide();
    $("#notreadmore" + id).show();
  };
  toggleDesLessAll = (id) => {
    $("#notreadmore" + id).hide();
    $("#readmore" + id).show();
  };

  toggleDesMore2 = () => {
    $("#readmore2").hide();
    $("#notreadmore2").show();
  };
  toggleDesLess2 = () => {
    $("#notreadmore2").hide();
    $("#readmore2").show();
  };
  viewclose() {
    this.setState({ visiblediscloser: false });
  }
  render() {
    const answer_array = this.props.location.pathname.split("/");

    // alert(answer_array);
    var company_name = answer_array[2];
    const {
      org,
      formData,
      count,
      text1,
      textmoreJDDesc,
      text2,
      text3,
      text4,
      text5,
      text6,
      text7,
      text8,
      text10,
      submitted,
      url,
      emp,
      organization_url_see,
      organization_logo_see,
      organization_title_see,
      textShort_Description,
      textJobTitle,
      isreadlong,
      user_id,
      isreadjddesc,
    } = this.state;

    let orgOp = org
      ? org.map((cell) => {
          return { value: cell.id, label: cell.title };
        })
      : "";

    let balance_div_url, balance_div_urlnew, balance_disclouser;
    const navPillStyle = {
      cursor: "pointer",
      color: "#fff",
      borderColor: "rgba(255,255,255,0.55)",
      background: "rgba(255,255,255,0.08)",
      borderRadius: "999px",
      padding: "7px 16px",
      fontSize: "13px",
      fontWeight: 600,
      display: "inline-flex",
      alignItems: "center",
      gap: "4px",
      textDecoration: "none",
      transition: "background 0.15s ease",
    };
    balance_disclouser =
      user_id !== "0" ? (
        <a
          target="_blank"
          className="mr-1 mb-1 btn btn-outline-secondary"
          style={navPillStyle}
          onClick={() => this.view()}
        >
          Show Disclosure
        </a>
      ) : (
        ""
      );

    balance_div_urlnew = (
      <a
        target="_blank"
        className="mr-1 mb-1 btn btn-outline-secondary"
        style={navPillStyle}
        href={myConstClass.CARREERCOMPANY_URL + "/" + company_name}
      >
        Login
      </a>
    );
    let organization_div_url, organization_title_url, organization_div_url_back;
    balance_div_url = url ? (
      <a target="_blank" className="mr-1 mb-1 btn btn-secondary" style={navPillStyle} href={url}>
        See on JOBlinks <Icon.ArrowUpRight size={15} style={{ cursor: "Pointer" }} />
      </a>
    ) : (
      ""
    );
    // organization_div_url=organization_url_see?<a target="_blank" href={organization_url_see}  >See on CamJOBS for this organization</a>:'';

    organization_title_url = organization_title_see ? (
      <span style={{ fontSize: "22px", fontWeight: 700, color: "#fff", marginLeft: "14px", letterSpacing: "-0.01em" }}>
        <label className="mb-0">{organization_title_see}</label>
      </span>
    ) : (
      ""
    );
    organization_div_url = organization_url_see ? (
      <a
        style={navPillStyle}
        className="mr-1 mb-1 btn btn-outline-secondary"
        href={organization_url_see}
        target="_blank"
      >
        See on JOBlinks <Icon.ArrowUpRight size={15} style={{ cursor: "Pointer" }} />
      </a>
    ) : (
      ""
    );
    organization_div_url_back = (
      <a
        style={navPillStyle}
        className="mr-1 mb-1 btn btn-outline-secondary"
        href={"/" + myConstClass.TENANT_PAGE_PATH + "attendance/checkinout"}
      >
        Back To Dashboard
      </a>
    );
    //organization_div_url_back=<Link to={'/'+myConstClass.TENANT_PAGE_PATH+"attendance/checkinout"} style={{margin:"0rem 1.50rem 1.50rem 0rem",border: "#6f42c1 1px solid",color: "#6f42c1",padding: "0.10rem 0.90rem 0.30rem 0.90rem",textDecoration: 'none',borderRadius:'0.2rem'}}>Back To Dashboard</Link>;
    //organization_div_url=organization_url_see?<Link to={organization_url_see} style={{margin:"0rem 1.50rem 1.50rem 0rem",border: "#6f42c1 1px solid",color: "#6f42c1",padding: "0.10rem 0.90rem 0.30rem 0.90rem",textDecoration: 'none',borderRadius:'0.2rem'}} target="_blank">{T("Cancel")}</Link>:'';

    let file_link, image_logo;
    file_link = myConstClass.SITE_URL + organization_logo_see;
    // image_logo=organization_logo_see?<img src={file_link}  style={{width: '134px',height:'77px',marginTop:'-23px'}}/>:'';

    image_logo = organization_logo_see ? (
      <img
        src={file_link}
        style={{ width: "120px", height: "60px", objectFit: "contain", borderRadius: "6px", background: "#fff", padding: "4px" }}
      />
    ) : (
      ""
    );

    let balance_div;
    let file_linknew, readmore;
    balance_div = formData
      ? formData.map((cell) => {
          if (cell.image) {
            file_linknew =
              myConstClass.CARREER_URL +
              this.state.account_name +
              `/uploads/job_post_image/` +
              cell.id +
              "/" +
              cell.image;
          } else {
            file_linknew = myConstClass.SITE_URL + `img/jobimage.png`;
          }

          readmore =
            cell.isread == "1" ? (
              <CardLink
                href="#"
                onClick={() => {}}
                style={{ color: UI.accent, fontWeight: 600, fontSize: "13px" }}
              >
                Read More
              </CardLink>
            ) : (
              ""
            );
          return (
            <Row className="mb-3" key={cell.id}>
              <Col lg={12}>
                <Card
                  style={{
                    border: `1px solid ${UI.border}`,
                    borderRadius: UI.radius,
                    boxShadow: UI.shadow,
                    transition: "box-shadow 0.15s ease, transform 0.15s ease",
                  }}
                  className="job-card"
                >
                  <CardBody className="p-3">
                    <Row className="align-items-center">
                      <Col lg={2} md={3} xs={4}>
                        <CardImg
                          style={{
                            height: "88px",
                            width: "100%",
                            objectFit: "cover",
                            borderRadius: UI.radiusSm,
                            border: `1px solid ${UI.border}`,
                          }}
                          src={file_linknew}
                        />
                      </Col>

                      <Col lg={7} md={6} xs={8}>
                        <div style={{ fontSize: "17px", fontWeight: 700, color: UI.text }}>
                          {cell.JobTitle}
                        </div>
                        <div style={{ color: UI.textMuted, fontSize: "14px", marginTop: "4px" }}>
                          {cell.Short_Description} {readmore}
                        </div>
                      </Col>
                      <Col lg={3} md={3} xs={12} className="mt-2 mt-md-0">
                        <div className="d-flex flex-wrap justify-content-lg-end" style={{ gap: "8px" }}>
                          <button
                            className="mr-1 mb-1 btn btn-outline-secondary"
                            style={{
                              borderRadius: "999px",
                              borderColor: UI.border,
                              color: UI.text,
                              fontWeight: 600,
                              fontSize: "13px",
                              padding: "7px 16px",
                            }}
                            onClick={() => this.toggledocTemplate1(cell.id)}
                          >
                            View More
                          </button>

                          <Button
                            style={{
                              background: UI.accent,
                              borderColor: UI.accent,
                              borderRadius: "999px",
                              fontWeight: 600,
                              fontSize: "13px",
                              padding: "7px 18px",
                            }}
                            onClick={() => this.toggledocTemplateApply(cell.id)}
                          >
                            Apply
                          </Button>
                        </div>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          );
        })
      : "";

    //for export csv

    return (
      <React.Fragment>
        <Navbar
          dark
          expand="xs"
          className="w-100 py-2"
          style={{
            background: `linear-gradient(120deg, ${UI.primaryDark} 0%, ${UI.primary} 55%, #1e4d8f 100%)`,
            minHeight: "84px",
            boxShadow: UI.shadowMd,
            position: "relative",
            zIndex: 10,
          }}
        >
          <Container className="d-flex align-items-center justify-content-between flex-wrap">
            <NavbarBrand className="font-weight-bold d-flex align-items-center">
              {image_logo}
              {organization_title_url}
            </NavbarBrand>

            <div className="d-flex align-items-center flex-wrap" style={{ gap: "8px" }}>
              {balance_disclouser}
              {organization_div_url}
              {/* {balance_div_urlnew} */}
            </div>
          </Container>
        </Navbar>
        {/* <Intro /> */}

        {/* <Navigation />*/}

        <section className="pt-7 pb-5" style={{ marginTop: 0, background: UI.surfaceMuted, minHeight: "60vh", paddingTop: "40px" }}>
          <Container>
            <div
              className="mb-4"
              style={{
                background: UI.surface,
                borderRadius: UI.radius,
                border: `1px solid ${UI.border}`,
                boxShadow: UI.shadow,
                padding: "28px 28px 22px",
              }}
            >
              <div className="text-center mb-3">
                <h2 className="mb-2" style={{ color: UI.text, fontWeight: 700, letterSpacing: "-0.01em" }}>
                  Available Jobs
                  <span
                    className="ml-2"
                    style={{
                      display: "inline-block",
                      background: UI.primaryLight,
                      color: UI.primary,
                      fontSize: "16px",
                      fontWeight: 700,
                      borderRadius: "999px",
                      padding: "3px 14px",
                      verticalAlign: "middle",
                    }}
                  >
                    {count - 1}
                  </span>
                </h2>
                <p className="mb-0" style={{ color: UI.textMuted, fontSize: "15px" }}>
                  Explore our current openings and find the role that fits you best.
                </p>
              </div>

              <AvForm id="pform">
                <Row className="c_row justify-content-center">
                  {/* <div class="col-md-6">
                 
                  <AvGroup>
                 <label>Select Organization</label>
                      <Select
                           value={organization_id1}
                           name="organization_id1"
                           onChange={this.change1}
                           options={orgOp1}
                          isClearable
                          placeholder='Select Organization'
                      />
	
	  </AvGroup>
  </div>*/}

                  <div className="col-md-6">
                    <AvGroup>
                      <label style={{ fontWeight: 600, color: UI.text, fontSize: "13px", textTransform: "uppercase", letterSpacing: "0.03em" }}>
                        Select Job Type
                      </label>
                      <Select
                        value={this.state.organization_id}
                        name="organization_id"
                        onChange={this.change}
                        options={orgOp}
                        //isClearable
                        placeholder="Select Job Type"
                      />
                    </AvGroup>
                  </div>
                </Row>
              </AvForm>
            </div>
            <br />

            {balance_div}
            <Modal
              size="lg"
              style={{ maxWidth: "900px", width: "100%" }}
              isOpen={this.state[this.state.jobpostid]}
              contentClassName="career-modal-content"
              //   toggle={() => this.toggleEdit(this.state.jobpostid)}
            >
              <AvForm
                id="doform"
                onValidSubmit={this.handleValidSubmitDocument}
              >
                <ModalHeader
                  style={{
                    background: `linear-gradient(120deg, ${UI.primaryDark} 0%, ${UI.primary} 100%)`,
                    color: "#fff",
                    borderBottom: "none",
                    borderTopLeftRadius: UI.radius,
                    borderTopRightRadius: UI.radius,
                    padding: "20px 24px",
                  }}
                  close={
                    <button
                      className="close"
                      style={{ color: "#fff", opacity: 0.8 }}
                      onClick={() => this.toggledocTemplate(this.state.jobpostid)}
                    >
                      ×
                    </button>
                  }
                >
                  <div style={{ fontSize: "18px", fontWeight: 700, color: "#fff" }}>
                    Applying For: {textJobTitle}
                  </div>
                  <div style={{ fontSize: "13px", color: "rgba(255,255,255,0.85)", fontWeight: 400, marginTop: "2px" }}>
                    {textShort_Description}
                  </div>
                </ModalHeader>
                <ModalBody style={{ background: UI.surfaceMuted, padding: "24px" }}>
                  <CardBody style={{ background: UI.surface, borderRadius: UI.radiusSm, border: `1px solid ${UI.border}`, boxShadow: UI.shadow }}>
                    <Row>
                      <Col lg={6}>
                        <AvGroup>
                          <Label for="example" style={{ fontWeight: 600, fontSize: "13px", color: UI.text }}>Name</Label>
                          <AvInput name="title" id="example" required />
                          <AvFeedback>Enter Name!</AvFeedback>
                        </AvGroup>
                      </Col>

                      <Col lg={6}>
                        <AvGroup>
                          <Label for="example" style={{ fontWeight: 600, fontSize: "13px", color: UI.text }}>Mobile No</Label>
                          <AvInput
                            name="mobile_no"
                            id="example"
                            type="number"
                            required
                          />
                          <AvFeedback>Enter Mobile No!</AvFeedback>
                        </AvGroup>
                      </Col>

                      <Col lg={6}>
                        <AvGroup>
                          <Label for="example" style={{ fontWeight: 600, fontSize: "13px", color: UI.text }}>Email</Label>
                          <AvInput
                            name="email"
                            type="email"
                            id="example"
                            required
                          />
                          <AvFeedback>Enter Email!</AvFeedback>
                        </AvGroup>
                      </Col>

                      <Col lg={6}>
                        <AvGroup>
                          <Label for="example" style={{ fontWeight: 600, fontSize: "13px", color: UI.text }}>Upload Resume</Label> <br />
                          <input
                            type="file"
                            id="file1"
                            name="file"
                            onChange={(e) => this.onDocChangeHandler(e)}
                            required
                          />
                          <AvFeedback>Upload Resume!</AvFeedback>
                        </AvGroup>
                        <small style={{ color: UI.textMuted }}>
                          ('png','jpg','jpeg','pdf','docs','JPG','txt')
                        </small>
                      </Col>

                      <Col lg={6}>
                        <AvGroup>
                          <Label for="example" style={{ fontWeight: 600, fontSize: "13px", color: UI.text }}>Linkedin Profile </Label>
                          <AvInput name="profile_url" id="example" type="url" />
                        </AvGroup>
                      </Col>

                      <Col lg={6}>
                        <AvGroup>
                          <Label for="example" style={{ fontWeight: 600, fontSize: "13px", color: UI.text }}>
                            Self Introductory Video{" "}
                            <span style={{ color: "#dc3545", fontSize: "12px", fontWeight: 400 }}>
                              embeded Video youtube url
                            </span>
                          </Label>
                          <AvInput name="self_url" id="example" type="text" />
                          <AvFeedback>Enter URL !</AvFeedback>
                        </AvGroup>
                      </Col>
                      <Col lg={6}>
                        <CustomInput
                          type="checkbox"
                          name="toplist"
                          id="exampleCustomCheckbox"
                          label="See and Approve Disclosure"
                          className="mb-2"
                          checked={this.state.checked}
                          onChange={this.handleCheckChange}
                        />
                      </Col>
                    </Row>
                  </CardBody>
                </ModalBody>
                <ModalFooter style={{ background: UI.surfaceMuted, borderTop: `1px solid ${UI.border}`, borderBottomLeftRadius: UI.radius, borderBottomRightRadius: UI.radius }}>
                  <div style={{ textAlign: "right", width: "100%" }}>
                    <button
                      className="mr-1 mb-1 btn btn-outline-secondary"
                      style={{ borderRadius: "999px", fontWeight: 600, padding: "8px 18px" }}
                      onClick={() =>
                        this.toggledocTemplate(this.state.jobpostid)
                      }
                    >
                      Close
                    </button>{" "}
                    <Button
                      style={{ background: UI.accent, borderColor: UI.accent, borderRadius: "999px", fontWeight: 600, padding: "8px 22px" }}
                      disabled={submitted}
                    >
                      Apply
                    </Button>
                  </div>
                </ModalFooter>
              </AvForm>
            </Modal>

            <Modal
              size="lg"
              style={{ maxWidth: "900px", width: "100%" }}
              isOpen={this.state.visiblepoints}
              contentClassName="career-modal-content"
              //toggle={() => this.toggleEdit(this.state.jobpostidnew)}
            >
              <ModalHeader
                style={{
                  background: `linear-gradient(120deg, ${UI.primaryDark} 0%, ${UI.primary} 100%)`,
                  color: "#fff",
                  borderBottom: "none",
                  borderTopLeftRadius: UI.radius,
                  borderTopRightRadius: UI.radius,
                  padding: "20px 24px",
                }}
                close={
                  <button
                    className="close"
                    style={{ color: "#fff", opacity: 0.8 }}
                    onClick={() => this.toggleEdit(this.state.jobpostidnew)}
                  >
                    ×
                  </button>
                }
              >
                <Row className="align-items-center">
                  <div style={{ width: "100%" }}>
                    <div style={{ fontSize: "18px", fontWeight: 700, color: "#fff" }}>{text2}</div>
                    <div className="mt-1">{balance_div_url}</div>
                  </div>
                </Row>

                <div style={{ fontSize: "13px", color: "rgba(255,255,255,0.85)", marginTop: "6px" }}>{text8}</div>
              </ModalHeader>
              <ModalBody className="m-9" style={{ background: UI.surface, padding: "10px 24px 20px" }}>
                <Table
                  size="sm"
                  borderless
                  className="my-2"
                >
                  <tbody>
                    <tr>
                      <th className="text-right" style={tablestyle}>
                        Job Type
                      </th>
                      <td className="text-left" style={tablestyletd}>
                        {text3}
                      </td>
                    </tr>
                    <tr>
                      <th className="text-right" style={tablestyle}>
                        Position
                      </th>
                      <td className="text-left" style={tablestyletd}>
                        {text4}
                      </td>
                    </tr>
                    <tr>
                      <th className="text-right" style={tablestyle}>
                        Date Of Closing
                      </th>
                      <td className="text-left" style={tablestyletd}>
                        {text5}
                      </td>
                    </tr>
                    <tr>
                      <th className="text-right" style={tablestyle}>
                        Date Of Posted
                      </th>
                      <td className="text-left" style={tablestyletd}>
                        {text10}
                      </td>
                    </tr>
                    <tr>
                      <th className="text-right" style={tablestyle}>
                        Minimum_Experience
                      </th>
                      <td className="text-left" style={tablestyletd}>
                        {text6}
                      </td>
                    </tr>
                    <tr>
                      <th className="text-right" style={tablestyle}>
                        Gender
                      </th>
                      <td className="text-left" style={tablestyletd}>
                        {text7}
                      </td>
                    </tr>
                    <tr>
                      <th className="text-right" style={tablestyle}>
                        Long Description
                      </th>
                      <td className="text-left" style={tablestyletd}>
                        <div id="readmore" style={{ display: "block" }}>
                          <ReactQuill
                            value={this.state.Longdescwithouthtml || ""}
                            readOnly={true}
                            theme={"bubble"}
                          />
                          {isreadlong == "1" ? (
                            <CardLink
                              href="#"
                              onClick={() =>
                                this.toggleDesMore(this.state.jobpostidnew)
                              }
                            >
                              Read More
                            </CardLink>
                          ) : (
                            ""
                          )}
                        </div>
                        <div id="notreadmore" style={{ display: "none" }}>
                          <ReactQuill
                            value={text1 || ""}
                            readOnly={true}
                            theme={"bubble"}
                          />
                          <CardLink
                            href="#"
                            onClick={() =>
                              this.toggleDesLess(this.state.jobpostidnew)
                            }
                          >
                            Show Less
                          </CardLink>
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <th className="text-right" style={tablestyle}>
                        Job Descripation Title
                      </th>
                      <td className="text-left" style={tablestyletd}>
                        {this.state.jdtitle}
                      </td>
                    </tr>

                    <tr>
                      <th className="text-right" style={tablestyle}>
                        Job Description
                      </th>
                      <td className="text-left" style={tablestyletd}>
                        <div id="readmore1" style={{ display: "block" }}>
                          <ReactQuill
                            value={this.state.JDdescwithouthtml || ""}
                            readOnly={true}
                            theme={"bubble"}
                          />
                          {isreadjddesc == "1" ? (
                            <CardLink
                              href="#"
                              onClick={() =>
                                this.toggleDesMore1(this.state.jobpostidnew)
                              }
                            >
                              Read More
                            </CardLink>
                          ) : (
                            ""
                          )}
                        </div>
                        <div id="notreadmore1" style={{ display: "none" }}>
                          <ReactQuill
                            value={textmoreJDDesc || ""}
                            readOnly={true}
                            theme={"bubble"}
                          />
                          <CardLink
                            href="#"
                            onClick={() =>
                              this.toggleDesLess1(this.state.jobpostidnew)
                            }
                          >
                            Show Less
                          </CardLink>
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <th className="text-right" style={tablestyle}>
                        Functions
                      </th>
                      <td className="text-left" style={tablestyletd}>
                        <div id="readmore2" style={{ display: "block" }}>
                          <ReactQuill
                            value={this.state.Functionsmore || ""}
                            readOnly={true}
                            theme={"bubble"}
                          />
                          {this.state.isreadfunction == "1" ? (
                            <CardLink
                              href="#"
                              onClick={() =>
                                this.toggleDesMore2(this.state.jobpostidnew)
                              }
                            >
                              Read More
                            </CardLink>
                          ) : (
                            ""
                          )}
                        </div>
                        <div id="notreadmore2" style={{ display: "none" }}>
                          <ReactQuill
                            value={this.state.Functions || ""}
                            readOnly={true}
                            theme={"bubble"}
                          />
                          <CardLink
                            href="#"
                            onClick={() =>
                              this.toggleDesLess2(this.state.jobpostidnew)
                            }
                          >
                            Show Less
                          </CardLink>
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <th className="text-right" style={tablestyle}>
                        Qualification
                      </th>
                      <td className="text-left" style={tablestyletd}>
                        <div id="readmore3" style={{ display: "block" }}>
                          <ReactQuill
                            value={this.state.Qualificationmore || ""}
                            readOnly={true}
                            theme={"bubble"}
                          />
                          {this.state.isreadQualification == "1" ? (
                            <CardLink
                              href="#"
                              onClick={() =>
                                this.toggleDesMore3(this.state.jobpostidnew)
                              }
                            >
                              Read More
                            </CardLink>
                          ) : (
                            ""
                          )}
                        </div>
                        <div id="notreadmore3" style={{ display: "none" }}>
                          <ReactQuill
                            value={this.state.Qualification || ""}
                            readOnly={true}
                            theme={"bubble"}
                          />
                          <CardLink
                            href="#"
                            onClick={() =>
                              this.toggleDesLess3(this.state.jobpostidnew)
                            }
                          >
                            Show Less
                          </CardLink>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <th className="text-right" style={tablestyle}>
                        Responsibilities
                      </th>
                      <td className="text-left" style={tablestyletd}>
                        <div id="readmore4" style={{ display: "block" }}>
                          <ReactQuill
                            value={this.state.Qualificationmore || ""}
                            readOnly={true}
                            theme={"bubble"}
                          />
                          {this.state.isreadResponsibilities == "1" ? (
                            <CardLink
                              href="#"
                              onClick={() =>
                                this.toggleDesMore4(this.state.jobpostidnew)
                              }
                            >
                              Read More
                            </CardLink>
                          ) : (
                            ""
                          )}
                        </div>
                        <div id="notreadmore4" style={{ display: "none" }}>
                          <ReactQuill
                            value={this.state.Responsibilities || ""}
                            readOnly={true}
                            theme={"bubble"}
                          />
                          <CardLink
                            href="#"
                            onClick={() =>
                              this.toggleDesLess4(this.state.jobpostidnew)
                            }
                          >
                            Show Less
                          </CardLink>
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <th className="text-right" style={tablestyle}>
                        Salary
                      </th>
                      <td className="text-left" style={tablestyletd}>
                        <div id="readmoreSalary" style={{ display: "block" }}>
                          <ReactQuill
                            value={this.state.Salarymore || ""}
                            readOnly={true}
                            theme={"bubble"}
                          />
                          {this.state.isreadSalary == "1" ? (
                            <CardLink
                              href="#"
                              onClick={() => this.toggleDesMoreAll("Salary")}
                            >
                              Read More
                            </CardLink>
                          ) : (
                            ""
                          )}
                        </div>
                        <div id="notreadmoreSalary" style={{ display: "none" }}>
                          <ReactQuill
                            value={this.state.Salary || ""}
                            readOnly={true}
                            theme={"bubble"}
                          />
                          <CardLink
                            href="#"
                            onClick={() => this.toggleDesLessAll("Salary")}
                          >
                            Show Less
                          </CardLink>
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <th className="text-right" style={tablestyle}>
                        Reporting
                      </th>
                      <td className="text-left" style={tablestyletd}>
                        <div
                          id="readmoreReporting"
                          style={{ display: "block" }}
                        >
                          <ReactQuill
                            value={this.state.Reportingmore || ""}
                            readOnly={true}
                            theme={"bubble"}
                          />
                          {this.state.isreadReporting == "1" ? (
                            <CardLink
                              href="#"
                              onClick={() => this.toggleDesMoreAll("Reporting")}
                            >
                              Read More
                            </CardLink>
                          ) : (
                            ""
                          )}
                        </div>
                        <div
                          id="notreadmoreReporting"
                          style={{ display: "none" }}
                        >
                          <ReactQuill
                            value={this.state.Reporting || ""}
                            readOnly={true}
                            theme={"bubble"}
                          />
                          <CardLink
                            href="#"
                            onClick={() => this.toggleDesLessAll("Reporting")}
                          >
                            Show Less
                          </CardLink>
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <th className="text-right" style={tablestyle}>
                        Shifts
                      </th>
                      <td className="text-left" style={tablestyletd}>
                        <div id="readmoreShifts" style={{ display: "block" }}>
                          <ReactQuill
                            value={this.state.Shiftsmore || ""}
                            readOnly={true}
                            theme={"bubble"}
                          />
                          {this.state.isreadShifts == "1" ? (
                            <CardLink
                              href="#"
                              onClick={() => this.toggleDesMoreAll("Shifts")}
                            >
                              Read More
                            </CardLink>
                          ) : (
                            ""
                          )}
                        </div>
                        <div id="notreadmoreShifts" style={{ display: "none" }}>
                          <ReactQuill
                            value={this.state.Shifts || ""}
                            readOnly={true}
                            theme={"bubble"}
                          />
                          <CardLink
                            href="#"
                            onClick={() => this.toggleDesLessAll("Shifts")}
                          >
                            Show Less
                          </CardLink>
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <th className="text-right" style={tablestyle}>
                        Perks
                      </th>
                      <td className="text-left" style={tablestyletd}>
                        <div id="readmorePerks" style={{ display: "block" }}>
                          <ReactQuill
                            value={this.state.Perksmore || ""}
                            readOnly={true}
                            theme={"bubble"}
                          />
                          {this.state.isreadPerks == "1" ? (
                            <CardLink
                              href="#"
                              onClick={() => this.toggleDesMoreAll("Perks")}
                            >
                              Read More
                            </CardLink>
                          ) : (
                            ""
                          )}
                        </div>
                        <div id="notreadmorePerks" style={{ display: "none" }}>
                          <ReactQuill
                            value={this.state.Perks || ""}
                            readOnly={true}
                            theme={"bubble"}
                          />
                          <CardLink
                            href="#"
                            onClick={() => this.toggleDesLessAll("Perks")}
                          >
                            Show Less
                          </CardLink>
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <th className="text-right" style={tablestyle}>
                        Benefits
                      </th>
                      <td className="text-left" style={tablestyletd}>
                        <div id="readmoreBenefits" style={{ display: "block" }}>
                          <ReactQuill
                            value={this.state.Benefitsmore || ""}
                            readOnly={true}
                            theme={"bubble"}
                          />
                          {this.state.isreadBenefits == "1" ? (
                            <CardLink
                              href="#"
                              onClick={() => this.toggleDesMoreAll("Benefits")}
                            >
                              Read More
                            </CardLink>
                          ) : (
                            ""
                          )}
                        </div>
                        <div
                          id="notreadmoreBenefits"
                          style={{ display: "none" }}
                        >
                          <ReactQuill
                            value={this.state.Benefits || ""}
                            readOnly={true}
                            theme={"bubble"}
                          />
                          <CardLink
                            href="#"
                            onClick={() => this.toggleDesLessAll("Benefits")}
                          >
                            Show Less
                          </CardLink>
                        </div>
                      </td>
                    </tr>

                    <tr></tr>
                  </tbody>
                </Table>
              </ModalBody>
              <ModalFooter style={{ background: UI.surfaceMuted, borderTop: `1px solid ${UI.border}`, borderBottomLeftRadius: UI.radius, borderBottomRightRadius: UI.radius }}>
                <Button
                  className="mr-1 mb-1 btn btn-outline-secondary"
                  style={{ borderRadius: "999px", fontWeight: 600, padding: "8px 18px" }}
                  onClick={() => this.toggleEdit(this.state.jobpostidnew)}
                >
                  Close
                </Button>
              </ModalFooter>
            </Modal>

            <Modal
              size="lg"
              style={{ maxWidth: "900px", width: "100%" }}
              isOpen={this.state.visiblepoints1}
              contentClassName="career-modal-content"
              //toggle={() => this.toggleEdit(this.state.jobpostidnew)}
            >
              <ModalHeader
                style={{
                  background: `linear-gradient(120deg, ${UI.primaryDark} 0%, ${UI.primary} 100%)`,
                  color: "#fff",
                  borderBottom: "none",
                  borderTopLeftRadius: UI.radius,
                  borderTopRightRadius: UI.radius,
                }}
              >
                <h4 className="mb-0" style={{ color: "#fff", fontWeight: 700 }}>View Long Description</h4>
              </ModalHeader>
              <ModalBody className="text-center m-9" style={{ background: UI.surfaceMuted, padding: "20px 24px" }}>
                <Card style={{ border: `1px solid ${UI.border}`, borderRadius: UI.radiusSm, boxShadow: UI.shadow }}>
                  <CardHeader style={{ background: UI.surface, borderBottom: `1px solid ${UI.border}` }}>
                    <CardTitle tag="h5" className="mb-0" style={{ color: UI.text, fontWeight: 700 }}>
                      Long Description of {text2}
                    </CardTitle>
                  </CardHeader>
                  <CardBody>
                    <Row>
                      <Col lg={12}>
                        <ReactQuill
                          value={this.state.text1}
                          readOnly={true}
                          theme={"bubble"}
                        />
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </ModalBody>
              <ModalFooter style={{ background: UI.surfaceMuted, borderTop: `1px solid ${UI.border}`, borderBottomLeftRadius: UI.radius, borderBottomRightRadius: UI.radius }}>
                <Button
                  className="mr-1 mb-1 btn btn-outline-secondary"
                  style={{ borderRadius: "999px", fontWeight: 600, padding: "8px 18px" }}
                  onClick={() => this.toggleEdit1(this.state.jobpostidnew)}
                >
                  Close
                </Button>
              </ModalFooter>
            </Modal>

            <Modal
              size="lg"
              style={{ maxWidth: "700px", width: "100%" }}
              isOpen={this.state.visiblediscloser}
              contentClassName="career-modal-content"
            >
              <ModalHeader
                style={{
                  background: `linear-gradient(120deg, ${UI.primaryDark} 0%, ${UI.primary} 100%)`,
                  borderBottom: "none",
                  borderTopLeftRadius: UI.radius,
                  borderTopRightRadius: UI.radius,
                }}
              />
              <ModalBody className="text-center m-9" style={{ background: UI.surface, padding: "20px 24px" }}>
                <CardBody>
                  <ReactQuill value={this.state.text} theme={"bubble"} />
                </CardBody>
              </ModalBody>
              <ModalFooter style={{ background: UI.surfaceMuted, borderTop: `1px solid ${UI.border}`, borderBottomLeftRadius: UI.radius, borderBottomRightRadius: UI.radius }}>
                <Button
                  style={{ background: UI.accent, borderColor: UI.accent, borderRadius: "999px", fontWeight: 600, padding: "8px 18px" }}
                  onClick={() => this.viewclose()}
                >
                  Close
                </Button>
              </ModalFooter>
            </Modal>
          </Container>
        </section>
        <style>{`
          .job-card:hover {
            box-shadow: ${UI.shadowMd};
            transform: translateY(-2px);
          }
          .career-modal-content {
            border-radius: ${UI.radius}px;
            overflow: hidden;
            border: none;
          }
        `}</style>
      </React.Fragment>
    );
  }
}
export default connect()(Landing);